
import { AssessmentAnswers } from '@/types/assessment';
import { categoryMapping } from '@/data/AIDigitalTransformationData';

export const calculateAssessmentScores = (
  scoredQuestions: any[],
  answers: AssessmentAnswers,
  categories: string[]
) => {
  const categoryScores: Record<string, { score: number; maxScore: number }> = {};
  
  // Initialiser toutes les catégories
  categories.forEach(category => {
    categoryScores[category] = { score: 0, maxScore: 0 };
  });
  
  // Calculer les scores pour chaque question
  scoredQuestions.forEach(question => {
    if (question.scores && answers[question.id]) {
      const mappedCategory = categoryMapping[question.category as keyof typeof categoryMapping] || question.category;
      const answer = answers[question.id];
      
      if (Array.isArray(answer)) {
        // Pour les questions à choix multiples, calculer le score moyen
        const scores = answer.map(a => {
          const idx = question.responses.indexOf(a);
          return idx !== -1 && question.scores ? question.scores[idx] : 0;
        });
        const avgScore = scores.reduce((sum, score) => sum + score, 0) / scores.length;
        
        if (!categoryScores[mappedCategory]) {
          categoryScores[mappedCategory] = { score: 0, maxScore: 0 };
        }
        categoryScores[mappedCategory].score += avgScore;
        categoryScores[mappedCategory].maxScore += Math.max(...(question.scores || [0]));
      } else {
        const answerIndex = question.responses.indexOf(answer as string);
        
        if (answerIndex !== -1 && question.scores[answerIndex] !== undefined) {
          if (!categoryScores[mappedCategory]) {
            categoryScores[mappedCategory] = { score: 0, maxScore: 0 };
          }
          categoryScores[mappedCategory].score += question.scores[answerIndex];
          categoryScores[mappedCategory].maxScore += Math.max(...question.scores);
        }
      }
    }
  });
  
  return categoryScores;
};

export const getFilteredQuestions = (
  allQuestions: any[],
  answers: AssessmentAnswers,
  excludeCategory?: string
) => {
  return allQuestions.filter(q => {
    if (excludeCategory && q.category === excludeCategory) return false;
    
    // Vérifier les conditions
    if (q.conditionalOn) {
      const conditionalAnswer = answers[q.conditionalOn];
      if (!q.conditionalResponse) return true;
      
      if (Array.isArray(q.conditionalResponse)) {
        return q.conditionalResponse.includes(conditionalAnswer as string);
      } else {
        return conditionalAnswer === q.conditionalResponse;
      }
    }
    
    return true;
  });
};

export const groupQuestionsByCategory = (
  questions: any[],
  categoryMapping: any
): Record<string, any[]> => {
  return questions.reduce((acc, question) => {
    const mappedCategory = categoryMapping[question.category as keyof typeof categoryMapping] || question.category;
    if (!acc[mappedCategory]) {
      acc[mappedCategory] = [];
    }
    acc[mappedCategory].push(question);
    return acc;
  }, {} as Record<string, any[]>);
};
